import { NgOtpInputConfig } from 'ng-otp-input';
import { NgxCurrencyConfig } from '@dintecom/ngx-currency';

export const otpConfig: NgOtpInputConfig = {
  length: 6,
  allowNumbersOnly: true,
  containerClass: 'd-flex',
};

export const maskConfig = {
  prefix: 'R',
  allowNegative: false,
  allowZero: false,
  nullable: true,
  inputMode: 1,
} as NgxCurrencyConfig;
